import loadable from '@/shared/utils/loadable';
import Loader from '@/shared/components/ui/loader';

export const NotFoundPage = loadable(() => import('@/app/routes/NotFoundPage'), {
  fallback: <Loader />,
});

export const DashboardLayout = loadable(() => import('@/app/layouts/DashboardLayout'), {
  fallback: <Loader />,
});

export const AuthLayout = loadable(() => import('@/app/layouts/AuthLayout'), {
  fallback: <Loader />,
});

export const LoginPage = loadable(() => import('@/features/auth/pages/LoginPage'), {
  fallback: <Loader />,
});

export const DashboardPage = loadable(() => import('@/features/dashboard/pages/DashboardPage'), {
  fallback: <Loader />,
});
export const AccountDetails = loadable(
  () => import('@/features/downline/pages/account-details/AccountDetails'),
  {
    fallback: <Loader />,
  }
);
export const AccountSummary = loadable(
  () => import('@/features/downline/pages/account-details/AccountSummary'),
  {
    fallback: <Loader />,
  }
);
export const TransactionHistory = loadable(
  () => import('@/features/downline/pages/account-details/TransactionHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserAccountStatement = loadable(
  () => import('@/features/downline/pages/account-details/UserAccountStatement'),
  {
    fallback: <Loader />,
  }
);

export const UserBetHistory = loadable(
  () => import('@/features/downline/pages/account-details/UserBetHistory'),
  {
    fallback: <Loader />,
  }
);
export const UserBettingPL = loadable(
  () => import('@/features/downline/pages/account-details/UserBettingPL'),
  {
    fallback: <Loader />,
  }
);

export const ActivityLog = loadable(
  () => import('@/features/downline/pages/account-details/ActivityLog'),
  {
    fallback: <Loader />,
  }
);
export const AllDownlineListing = loadable(
  () => import('@/features/downline/pages/AllDownlineListing'),
  {
    fallback: <Loader />,
  }
);
export const Settlement = loadable(() => import('@/features/downline/pages/Settlement'), {
  fallback: <Loader />,
});

export const SubUsers = loadable(() => import('@/features/downline/pages/SubUsers'), {
  fallback: <Loader />,
});

// Content management
export const ContentManagement = loadable(
  () => import('@/features/content-management/pages/ContentManagementPage'),
  { fallback: <Loader /> }
);
export const BannerManagement = loadable(
  () => import('@/features/content-management/pages/BannerManagementPage'),
  {
    fallback: <Loader />,
  }
);
export const SupportContactManagement = loadable(
  () => import('@/features/content-management/pages/SupportContactManagementPage'),
  {
    fallback: <Loader />,
  }
);
export const NotificationManagement = loadable(
  () => import('@/features/content-management/pages/NotificationManagementPage'),
  {
    fallback: <Loader />,
  }
);

export const ActivityLogsPage = loadable(
  () => import('@/features/activity-logs/pages/ActivityLogsPage'),
  {
    fallback: <Loader />,
  }
);

export const AccountStatementPage = loadable(
  () => import('@/features/account-statement/pages/AccountStatementPage'),
  {
    fallback: <Loader />,
  }
);

// Event Management
export const EventManagement = loadable(
  () => import('@/features/event-management/pages/EventManagement'),
  {
    fallback: <Loader />,
  }
);

export const BetSetting = loadable(() => import('@/features/event-management/pages/BetSetting'), {
  fallback: <Loader />,
});

// Change password
export const SettingsPage = loadable(() => import('@/features/auth/pages/ChangePasswordPage'), {
  fallback: <Loader />,
});

// reports

// Reports
export const BetList = loadable(() => import('@/features/reports/pages/BetList'), {
  fallback: <Loader />,
});

export const PlDownline = loadable(() => import('@/features/reports/pages/PlDownline'), {
  fallback: <Loader />,
});

export const PlByPlayer = loadable(() => import('@/features/reports/pages/PlByPlayer'), {
  fallback: <Loader />,
});

export const PlByEvent = loadable(() => import('@/features/reports/pages/PlByEvent'), {
  fallback: <Loader />,
});

export const BusinessReports = loadable(() => import('@/features/reports/pages/BusinessReports'), {
  fallback: <Loader />,
});

export const ExportHistoryPage = loadable(
  () => import('@/features/export-history/pages/ExportHistoryPage'),
  {
    fallback: <Loader />,
  }
);

// Risk Management
export const Risk = loadable(() => import('@/features/risk-management/pages/Risk'), {
  fallback: <Loader />,
});

// self deposit
export const SelfDepositPage = loadable(() => import('@/features/self-deposit/pages/SelfDeposit'), {
  fallback: <Loader />,
});

// change transaction code
export const ChangeTransactionCodePage = loadable(
  () => import('@/features/change-transaction-code/pages/ChangeTransectionCode'),
  {
    fallback: <Loader />,
  }
);
